// export const MATRIX_API_PREFIX = 'https://agent.fkxiaoyu.com/matrix-api/v2';
export const MATRIX_API_PREFIX = '/matrix-api/v2';

const buildUrl = (path: string) => `${MATRIX_API_PREFIX}${path}`;

export const MATRIX_API = {
    // Device endpoints.
    device: {
        list: buildUrl('/device/list'),
        summary: buildUrl('/device/summary'),
        logout: buildUrl('/device/logout'),
        changeGroup: buildUrl('/device/change_group'),
    },

    // Device admin endpoints.
    deviceAdmin: {
        create: buildUrl('/device_admin/create'),
        delete: buildUrl('/device_admin/delete'),
        get: buildUrl('/device_admin/get'),
        list: buildUrl('/device_admin/list'),
        listArea: buildUrl('/device_admin/list_area'),
        update: buildUrl('/device_admin/update'),
    },

    // Device group endpoints.
    deviceGroup: {
        create: buildUrl('/device_group/create'),
        delete: buildUrl('/device_group/delete'),
        list: buildUrl('/device_group/list'),
        update: buildUrl('/device_group/update'),
    },

    // Job/task endpoints.
    job: {
        action: (action: string) => `/job/${action}`,
        chat: buildUrl('/job/chat'),
        list: buildUrl('/job/list'),
        statistic: buildUrl('/job/statistic'),
        active: {
            create: buildUrl('/job/active/create'),
            get: buildUrl('/job/active/get'),
            list: buildUrl('/job/active/list'),
        },
    },

    // KOL pool endpoints.
    kolpool: {
        chat: buildUrl('/kolpool/chat'),
        list: buildUrl('/kolpool/list'),
    },

    // Mail endpoints.
    mail: buildUrl('/mail'),

    // WeChat official account (gzhkol) endpoints.
    wechatOfficialAccount: buildUrl('/wechatofficialaccount'),

    // XHS comment endpoints.
    xhsComment: {
        get: buildUrl('/xhs_comment/get'),
        getMsgConfig: buildUrl('/xhs_comment/get_msg_config'),
        getNotify: buildUrl('/xhs_comment/get_notify'),
        records: buildUrl('/xhs_comment/records'),
        set: buildUrl('/xhs_comment/set'),
        setMsgConfig: buildUrl('/xhs_comment/set_msg_config'),
        setNotify: buildUrl('/xhs_comment/set_notify'),
    },

    // XHS group endpoints.
    xhsGroup: {
        chatBase: buildUrl('/xhs_group/chat'),
        groupBase: buildUrl('/xhs_group/group'),
        group: {
            get: buildUrl('/xhs_group/group/get'),
            getStat: buildUrl('/xhs_group/group/getStat'),
            noteList: buildUrl('/xhs_group/group/note/list'),
            pause: buildUrl('/xhs_group/group/pause'),
            records: buildUrl('/xhs_group/group/records'),
            set: buildUrl('/xhs_group/group/set'),
        },
        noteRefresh: buildUrl('/xhs_group/note/refresh'),
        commentChat: {
            configGet: buildUrl('/xhs_group/comment_chat/config/get'),
            configSet: buildUrl('/xhs_group/comment_chat/config/set'),
            dataList: buildUrl('/xhs_group/comment_chat/data/list'),
            privateSend: buildUrl('/xhs_group/comment_chat/private/send'),
            summaryStat: buildUrl('/xhs_group/comment_chat/summary/stat'),
        },
        noteComment: {
            list: buildUrl('/xhs_group/note_comment/list'),
            noteStat: buildUrl('/xhs_group/note_comment/note_stat'),
            commentStat: buildUrl('/xhs_group/note_comment/comment_stat'),
            send: buildUrl('/xhs_group/note_comment/send'),
        },
        commentReply: {
            list: buildUrl('/xhs_group/comment_reply/list'),
            send: buildUrl('/xhs_group/comment_reply/send'),
        },
        messageChat: {
            configGet: buildUrl('/xhs_group/message_chat/config/get'),
            configSet: buildUrl('/xhs_group/message_chat/config/set'),
            dataList: buildUrl('/xhs_group/message_chat/data/list'),
        },
    },
} as const;
